// Manufacturing Order rows — how much of the row's Qty needs Paint / Fabric finish.
// A saved value of null with the flag on means the whole Qty (older rows).
export const QTY_FINISHES = [
  { flag: 'is_paint_finish', key: 'paint_qty', rest: '_paint_rest', full: '_paint_full', label: 'Paint Finish', short: 'Paint' },
  { flag: 'is_fabric_finish', key: 'fabric_qty', rest: '_fabric_rest', full: '_fabric_full', label: 'Fabric Finish', short: 'Fabric' },
];

const num = v => (v === '' || v === null || v === undefined ? NaN : Number(v));
const round2 = n => Math.round(n * 100) / 100;

// Qty with this finish (0 when the flag is off)
export function finishQtyOf(it, f) {
  if (!it?.[f.flag]) return 0;
  const v = num(it[f.key]);
  return Number.isFinite(v) ? v : (Number(it.qty) || 0);
}

// Qty without this finish
export const restQtyOf = (it, f) => round2((Number(it.qty) || 0) - finishQtyOf(it, f));

// Problem with a row's finish quantity, or null
export function finishQtyError(it, f) {
  if (!it?.[f.flag]) return null;
  const total = num(it.qty);
  const q = num(it[f.key]);
  const rest = it[f.rest];
  if (it[f.key] === '' || (it[f.key] != null && !Number.isFinite(q))) return `Enter the ${f.short.toLowerCase()} quantity`;
  if (Number.isFinite(q) && q <= 0) return `${f.label} quantity must be more than 0`;
  if (rest !== undefined && rest !== null) {
    const r = num(rest);
    if (!Number.isFinite(r) || r < 0) return `Quantity without ${f.short.toLowerCase()} can't be negative or empty`;
    if (Number.isFinite(total) && r >= total) return `Quantity without ${f.short.toLowerCase()} must be less than the item Qty`;
  }
  if (Number.isFinite(total) && Number.isFinite(q) && q > total) return `${f.label} quantity can't be more than the item Qty (${total})`;
  return null;
}

// Item Qty changed: a finish that covers the whole Qty follows it; a part is kept as typed
// (the row shows an error if it no longer fits). "Without" is always recalculated.
// Whether a finish covers the whole Qty is decided when it is set, not while Qty is typed.
export const coversAll = (it, f) => it[f.full] ?? (it[f.key] == null || it[f.key] === '' || Number(it[f.key]) === Number(it.qty));

export function onItemQtyChange(it, newQtyRaw) {
  const patch = { qty: newQtyRaw };
  const newQ = num(newQtyRaw);
  for (const f of QTY_FINISHES) {
    if (!it[f.flag]) continue;
    const all = coversAll(it, f);
    patch[f.full] = all;
    patch[f.rest] = undefined;
    if (all && Number.isFinite(newQ) && newQ > 0) patch[f.key] = newQ;
  }
  return patch;
}

// Strip the screen-only helper fields before saving
export const cleanFinishFields = it => {
  const { _paint_rest, _fabric_rest, _paint_full, _fabric_full, ...rest } = it;
  return rest;
};
